export default {
	// 网站索引
	indexDate: '/admin/forword/index/date', // 时间段统计数据
	indexQueryDate: '/admin/forword/index/query', // 网址列表
	indexSummary: '/admin/forword/index/summary', // 汇总数据
};
